import React from "react";
import { WithTooltip } from "shared/table-helpers";
import { faPencilAlt, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { format } from "date-fns";
import { DATE_FNS_SHORT_DATE_FORMAT } from "shared/constants";

export const buildColumns = (onMessageEdit, onDelete) => {
    return [
        {
            Header: "Message",
            filterable: false,
            accessor: "message",
            Cell: (row) => {
                return WithTooltip(row.value);
            },
        },
        {
            Header: "Start date",
            accessor: "startDate",
            filterable: false,
            Cell: (row) => {
                return format(new Date(row.value), DATE_FNS_SHORT_DATE_FORMAT);
            },
        },
        {
            Header: "End date",
            accessor: "endDate",
            filterable: false,
            Cell: (row) => {
                return format(new Date(row.value), DATE_FNS_SHORT_DATE_FORMAT);
            },
        },
        {
            Header: "Group",
            accessor: "messageGroup",
            filterable: false,
        },
        {
            Header: "Active",
            accessor: "isActive",
            filterable: false,
            Cell: (row) => {
                return row.value ? "Yes" : "No";
            },
        },
        {
            // accessor: null,
            sortable: false,
            Cell: ({ row }) => {
                return (
                    <button className="button -text" onClick={() => onMessageEdit(row)}>
                        <FontAwesomeIcon icon={faPencilAlt} />
                    </button>
                );
            },
            filterable: false,
            width: 40,
        },
        {
            // Header: WithIcon("Notes", faStickyNote),
            // accessor: null,
            sortable: false,
            Cell: ({ row }) => {
                return (
                    <button className="button -text" onClick={() => onDelete(row)}>
                        <FontAwesomeIcon icon={faTrash} />
                    </button>
                );
            },
            filterable: false,
            width: 40,
        },
    ];
};
